import * as _PortOne from '@portone/browser-sdk/v2';
import { v4 as uuidv4 } from 'uuid';

export const getPortOneConfig = (redirectUrl: string = window.location.href) => ({
  storeId: import.meta.env.VITE_APP_PORTONE_STORE_ID ?? '',
  identityVerificationId: `identity-verification-${uuidv4()}`,
  channelKey: import.meta.env.VITE_APP_PORTONE_CHANNEL_KEY ?? '',
  windowType: { pc: _PortOne.Entity.WindowType.POPUP, mobile: _PortOne.Entity.WindowType.REDIRECTION },
  redirectUrl,
});
